var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"-mb-1 italic font-semibold tracking-wide",class:[_vm.size === 'large' ? 'text-8xl lg:text-9xl' : 'text-5xl lg:text-7xl']},[(_vm.darkMode === 'dark')?_c('GlitchDark',{attrs:{"text":_vm.text}}):_c('GlitchLight',{attrs:{"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }